import { Preferences } from "@capacitor/preferences";
import { getBaseUrl } from "@/lib/apiClient";

const API_BASE_URL_KEY = "mebi_api_base_url";

const LEGACY_AUTH_STORAGE_KEYS = [
  "access_token",
  "mebi-app-state",
  "mebi-auth-store",
  "mebi-current-role",
  "mebi-persisted-role",
  "mebi_remember_account",
];

/**
 * Native app updates retain Capacitor Preferences and WebView local storage.
 * Clear the previous environment's session before auth queries run whenever
 * this build points at a different API (or before the first tracked launch).
 */
export const initializeApiEnvironment = async (): Promise<void> => {
  const apiBaseUrl = getBaseUrl();
  const { value: previousApiBaseUrl } = await Preferences.get({
    key: API_BASE_URL_KEY,
  });

  if (previousApiBaseUrl === apiBaseUrl) return;

  await Promise.all([
    Preferences.remove({ key: "access_token" }),
    Preferences.remove({ key: "mebi_remember_login" }),
    Preferences.remove({ key: "mebi_saved_accounts" }),
    Preferences.remove({ key: "mebi_selected_account" }),
  ]);

  if (globalThis.window?.localStorage) {
    for (const key of LEGACY_AUTH_STORAGE_KEYS) {
      globalThis.window.localStorage.removeItem(key);
    }
  }

  await Preferences.set({ key: API_BASE_URL_KEY, value: apiBaseUrl });
};
